// src/components/settings/CommunicationsSettings.js
import React, { useState, useEffect } from 'react';
import { Bell, Mail, Zap, MessageSquare, Users } from 'lucide-react';
import JobReminderSettings from './JobReminderSettings';
import EmailTemplatesSettings from './EmailTemplatesSettings';
import AutomationSettings from './AutomationSettings';
import QuoteFollowUpSettings from './QuoteFollowUpSettings';
import LeadNotificationSettings from './LeadNotificationSettings';
import { db } from '../../firebase/config';
import { doc, onSnapshot } from 'firebase/firestore';
import { resolveDocTerminology } from '../../utils/quoteSchema';

const TABS = [
    { key: 'reminders',         label: 'Job Reminders',      icon: Bell },
    { key: 'quoteFollowUp',     label: 'Quote Follow-ups',   icon: MessageSquare },
    { key: 'leadNotifications', label: 'Lead Notifications', icon: Users },
    { key: 'emailTemplates',    label: 'Email Templates',    icon: Mail },
    { key: 'automation',        label: 'Invoice Automation', icon: Zap },
];

export default function CommunicationsSettings({ currentUserProfile }) {
    const [activeTab, setActiveTab] = useState('reminders');

    // r1-p2-docterm-commsettings-e6b1f3a9 — org-default term for the tab label (aggregate surface)
    const orgId = currentUserProfile?.organizationId;
    const [docWord, setDocWord] = useState('Quote');
    useEffect(() => {
        if (!orgId) return;
        return onSnapshot(doc(db, 'organizations', orgId), (snap) => {
            if (snap.exists()) {
                setDocWord(resolveDocTerminology(snap.data().quoteTerminologyDefault).word);
            }
        });
    }, [orgId]);

    return (
        <div>
            {/* Sub-tab bar */}
            <div className="flex border-b border-gray-200 px-6 pt-5 flex-wrap gap-y-1">
                {TABS.map(({ key, label, icon: Icon }) => (
                    <button
                        key={key}
                        onClick={() => setActiveTab(key)}
                        className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium -mb-px border-b-2 transition-colors mr-1 ${
                            activeTab === key
                                ? 'border-blue-600 text-blue-700'
                                : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                    >
                        <Icon size={14} />
                        {label.replace('Quote', docWord)}
                    </button>
                ))}
            </div>

            {/* Content */}
            {activeTab === 'reminders'         && <JobReminderSettings         currentUserProfile={currentUserProfile} />}
            {activeTab === 'quoteFollowUp'     && <QuoteFollowUpSettings       currentUserProfile={currentUserProfile} />}
            {activeTab === 'leadNotifications' && <LeadNotificationSettings    currentUserProfile={currentUserProfile} />}
            {activeTab === 'emailTemplates'    && <EmailTemplatesSettings      currentUserProfile={currentUserProfile} />}
            {activeTab === 'automation'        && <AutomationSettings          currentUserProfile={currentUserProfile} />}
        </div>
    );
}